<script setup lang="ts">
  import { PhMagnifyingGlass } from '@phosphor-icons/vue';
  import { reactiveOmit } from '@vueuse/core';

  import type { InputProps } from '@ui/components/input';
  import { InputGroup, InputGroupAddon, InputGroupInput } from '@ui/components/input-group';

  const props = withDefaults(defineProps<InputProps>(), { placeholder: 'Search...' });

  defineOptions({ inheritAttrs: false });

  const inputProps = reactiveOmit(props, 'class');
</script>

<template>
  <!--  @vue-ignore -->
  <InputGroup :class="props.class" :size="props.size">
    <InputGroupInput v-bind="{ ...inputProps, ...$attrs }" />
    <InputGroupAddon>
      <PhMagnifyingGlass />
    </InputGroupAddon>

    <slot />
  </InputGroup>
</template>

<style scoped></style>
